import ProgressCard from "./ProgressCard";
import ActivityChart from "./ActivityChart";
import Leaderboard from "../utils/Leaderboard";
import { ClassListType } from "utils/interfaces";
import { usePlatform } from "components/utils/PlatformContext";
import { useEffect, useState } from "react";
import { getCollectionRequest } from "services/apiRequests";

interface ClassDashboardProps {
  classData: ClassListType;
}

const ClassDashboard: React.FC<ClassDashboardProps> = ({ classData }) => {
  const { studentsTerminology } = usePlatform();
  const [isLoadingStatistics, setIsLoadingStatistics] = useState(true);
  const [progress, setProgress] = useState(0);
  const [aptitude, setAptitude] = useState(0);

  const getClassStatistics = async () => {
    // First of all, set the state
    setIsLoadingStatistics(true);

    // Get the data
    const response = await getCollectionRequest(
      `/api/classes/statistics/${classData._id}`
    );

    // Stop the animation
    setIsLoadingStatistics(false);

    // Check if the response went right
    if (!response.successful) return;

    // Get the statistics
    const statistics = response.content;

    // Assign to their states
    setProgress(statistics.progressRate);
    setAptitude(statistics.aptitudeRate);
  };

  /**
   * Get the statistics when the card is rendered
   */
  useEffect(() => {
    getClassStatistics();
  }, []);

  return (
    <div className="w-full h-full justify-start flex-col inline-flex gap-8 overflow-y-auto overflow-x-hidden custom-scroll">
      <div className="w-full flex gap-8">
        <ProgressCard
          value={classData.students ? classData.students.length : 0}
          progressType="Active students"
        >
          <span className="font-semibold">
            {classData.students ? classData.students.length : 0}
          </span>{" "}
          {studentsTerminology.toLowerCase()} enrolled in this class
        </ProgressCard>
        <ProgressCard value={progress} progressType={"Progress"}>
          Average completion of assigned projects
        </ProgressCard>
        <ProgressCard value={aptitude} progressType={"Aptitude"}>
          Average score on completed projects
        </ProgressCard>
      </div>
      <div className="w-full flex gap-8">
        <Leaderboard
          userClassId={classData._id}
          showStatus={false}
          leaderboardName={classData.leaderboard?.name}
        />
        <ActivityChart userClassId={classData._id} />
      </div>
    </div>
  );
};

export default ClassDashboard;
